export default "__VITE_ASSET__DOvP4wfS__"